<app-page-header [title]="'Manufacturers'" [subtitle]="'Manage manufacturers in your system'"></app-page-header>

<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="search" [(ngModel)]="search" autocomplete="off" (input)="onSearchInputChange()">
            </p-iconfield>
            <label for="search">Search by name</label>
        </p-ifta-label>
        <p-button (click)="openCreateManufacturerDialog()" icon="pi pi-plus" isMaintainer
                  label="Add Manufacturer"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="manufacturers"
                [paginator]="true"
                [rows]="rows"
                [totalRecords]="totalRecords"
                [lazy]="true"
                [loading]="loading"
                [first]="currentPage * rows"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Contract expiration</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-manufacturer>
                <tr>
                    <td>{{ manufacturer.name }}</td>
                    <td>
                        {{ manufacturer.address?.street }},
                        {{ manufacturer.address?.zipCode }},
                        {{ manufacturer.address?.city }},
                        {{ manufacturer.address?.country }}
                    </td>
                    <td>{{ manufacturer.mail }}</td>
                    <td>{{ manufacturer.contractExpirationDate | formatDate }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button
                                    icon="pi pi-eye"
                                    text
                                    pTooltip="View manufacturer"
                                    tooltipPosition="left"
                                    routerLink="/manufacturers/manufacturer/{{manufacturer.id}}">
                            </p-button>

                            <p-button
                                    isMaintainer
                                    icon="pi pi-pencil"
                                    text
                                    pTooltip="Edit manufacturer"
                                    tooltipPosition="left"
                                    (click)="editManufacturer(manufacturer)">
                            </p-button>

                            <p-button
                                    isMaintainer
                                    icon="pi pi-trash"
                                    text
                                    pTooltip="Delete manufacturer"
                                    tooltipPosition="left"
                                    (click)="deleteManufacturer(manufacturer)"
                                    severity="danger">
                            </p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<div class="flex gap-2 mb-6">
    <p-button label="Export all Manufacturers" icon="pi pi-download" (click)="this.exportManufacturers()"
              severity="secondary"></p-button>
</div>

<app-create-manufacturer-dialog
        [(visible)]="displayCreateManufacturerDialog"
        (manufacturerCreated)="loadManufacturers()"
></app-create-manufacturer-dialog>

<app-update-manufacturer-dialog
        [(visible)]="displayUpdateManufacturerDialog"
        [manufacturer]="selectedManufacturer"
        (manufacturerUpdated)="loadManufacturers()"
></app-update-manufacturer-dialog>
